import { Box, Button } from '@mui/material';
import { useStore } from '../../../store/store';
import { useState } from 'react';
import { MAKE_WEBHOOKS } from '../../../utils/constants';
import axios from 'axios';

type SalariesReceiptsSendEmailButtonProps = {
  selectedYear: number;
  selectedMonth: number;
  buttonText: string;
};

export const SalariesReceiptsSendEmailButton = ({ selectedYear, selectedMonth, buttonText }: SalariesReceiptsSendEmailButtonProps) => {
  const [isUploading, setIsUploading] = useState(false);
  const { notifications } = useStore()

  const handleSendEmail = async () => {
    const confirmed = window.confirm(`Os recibos do mês ${selectedMonth + 1} do ano ${selectedYear} serão enviados por email a todos os colaboradores. Continuar?`);
    
    if (!confirmed) {
      return;
    }

    setIsUploading(true);

    const data = {
      year: selectedYear,
      month: selectedMonth + 1
    };
    
    try {
      await axios.post(MAKE_WEBHOOKS.send_staff_receipts_finance, data);
      notifications.setNotification({ isOpen: true, message: "Recibos enviados com sucesso", severity: "success" });
    } catch (error) {
      notifications.setNotification({ isOpen: true, message: "Erro ao enviar email", severity: "error" });
    } finally {
      setIsUploading(false);
    }
  };

  return (
    <Box>
      <Button variant="contained" component="label" disabled={isUploading} sx={{ minWidth: 200 }} color="secondary" onClick={handleSendEmail}>
        {isUploading ? "A enviar..." : buttonText}
      </Button>
    </Box>
  );
};